import { Layer } from '@/model/document2/page/surface/design/layer/layer'
import { Design } from '@/model/document2/page/surface/design/design'

export class LayerHelper
{
    // 一つ上のレイヤーを取得する
    public static getUpperLayer(layer : Layer, design : Design) : Layer | null
    {
        let upper;

        let parent = design.getParentLayer(layer);
        // このレイヤーの親がない場合は一つ上のレイヤーは存在しない
        if(parent == null) return null;

        let index = parent.getLayerIndex(layer);
        if(index + 1 < parent.getLayerCount())
        {
            // 一つインデックスを進めたレイヤーが上のレイヤーとなる。
            upper = parent.getLayer(index + 1); 
        }
        else
        {
            // このレイヤーは親レイヤーの中で一番上なので、親レイヤーの一つ上のレイヤーを取得する
            upper = this.getUpperLayer(parent, design);
        }

        return upper;
    }

    // 一つ下のレイヤーを取得する
    public static getLowerLayer(layer : Layer, design : Design) : Layer | null
    {
        let lower;

        let parent = design.getParentLayer(layer);
        // このレイヤーの親がない場合は一つ下のレイヤーは存在しない
        if(parent == null) return null;

        let index = parent.getLayerIndex(layer);
        if(index - 1 >= 0)
        {
            // 一つインデックスを戻したレイヤーが下のレイヤーとなる。
            lower = parent.getLayer(index - 1); 
        }
        else
        {
            // このレイヤーは親レイヤーの中で一番下なので、親レイヤーの一つ下のレイヤーを取得する
            lower = this.getLowerLayer(parent, design);
        }

        return lower;
    }
}